// 关闭类型
export enum CloseType {
    // 右上角的按钮
    RIGHT_CLOSE = 4,
    // 取消按钮
    BUTTON_CLOSE = 3,
}

// 确认类型
export enum ConfirmType {
    // 去开通
    GO_TO_OPEN = 1,
    // 知道了按钮
    KNOW_BUTTON = 2,
}

// 弹框类型
export enum DialogType {
    // 小程序无法支付
    MINIPROGRAM_CAN_NOT_PAY = -100,
    // 存储阻断, 创建者超容
    SIZE_LIMIT_OWNER = 100,
    // 存储阻断, 协作空间owner
    SIZE_LIMIT_COOPERATION_OWNER = 101,
    // 存储阻断, 协作空间协作者
    SIZE_LIMIT_COOPERATION_COLLABOR = 102,
    // 存储阻断, 转让场景，接受者不够的情况
    SIZE_LIMIT_TRANSFER = 103,
    // 存储阻断, 生成副本
    SIZE_LIMIT_DUPLICATE_OWNER = 104,
    // 存储阻断, 生成副本
    SIZE_LIMIT_DUPLICATE_COLLABOR = 105,
    // 存储阻断, 在回收站中恢复文档, 协作空间 owner
    SIZE_LIMIT_RECOVER_OWNER = 106,
    // 存储阻断, 在回收站中恢复文档, 协作空间协作者
    SIZE_LIMIT_RECOVER_COLLABOR = 107,
    // 存储阻断, SVIP
    SIZE_LIMIT_VIP = 108,
}

// 业务类型
export enum EntranceType {
    // 本人导入、上传、移动
    SELF_UPLOAD = 1,
    // 协作者导入、上传、移动
    COLLABORATOR_UPLOAD = 2,
    // 本人接收、转让
    SELF_RECEIVE = 3,
    // 本人生成副本
    SELF_BACKUP = 4,
    // 协作者生成副本
    COLLABORATOR_BACKUP = 5,
    // 本人还原删除文件
    SELF_RECOVER = 6,
    // 协作者还原删除文件
    COLLABORATOR_RECOVER = 7,
}

// 超限失败API code
export enum ApiErrorCode {
    // 生成副本失败、本人空间还原文件失败
    SELF_FAIL = 20010,
    // 协作者还原他人空间文件失败
    COOPERATOR_FAIL = 20013,
}

// dc弹框组件配置
export interface CommonDialogOptions {
    // 展示弹窗的时候需要做的事情
    onShow?: () => {};
    // 需要展示的Dialog类型
    type: DialogType;
    // onClose关闭的时候想做的事
    onClose?: (closeType: CloseType) => void;
    // confirm的时候做的事情
    onConfirm?: (confirm: ConfirmType) => void;
    // report 上报需要的参数
    report?: {
        ver7?: number;
        ver9?: number;
    };
    // 展示pay组件点击右上角的时候 是否要返回回收站
    needReturnToTrash?: boolean;
}
